<template>
  <div class="tusee-container-deactivate">
    <h1 style="text-align: center;margin: 50px;font-size: 0.6rem;">Deactivate tusee account</h1>
    <van-form @submit="onSubmit">
      <van-field
        v-model="data1"
        name="User ID"
        label="User ID"
        placeholder="Please enter the account ID you want to delete, see the personal page for details"
        :rules="[{ required: true, message: 'Please enter the account ID you want to delete, see the personal page for details' }]"
      />
      <van-field
      v-model="data2"
        name="User Nickname"
        label="User Nickname"
        placeholder="Please enter the account nickname you want to delete, see the personal page for details"
        :rules="[{ required: true, message: 'Please enter the account nickname you want to delete, see the personal page for details' }]"
      />
      <van-field
      v-model="data3"
        name="Contact Email"
        label="Contact Email"
        placeholder="Please enter an email address where we can contact you"
        :rules="[{ required: true, message: 'Please enter an email address where we can contact you' }]"
      />
      <van-field
      v-model="data4"
        name="Remark"
        label="Remark"
        placeholder="If you have other suggestions or requests, please enter them here"
        :rules="[{ required: false, message: 'If you have other suggestions or requests, please enter them here' }]"
      />
      <van-checkbox-group style="margin-top: 30px;" v-model="checkboxGroup" direction="horizontal">
        You acknowledge and authorize the developer of this app to use your information to satisfy your request to delete your account data.
        <van-checkbox name="1">Confirm</van-checkbox>
        <br>
        <br>
        Your account and related data will be permanently deleted and cannot be recovered.
        <van-checkbox name="2">Confirm</van-checkbox>
      </van-checkbox-group>

      <div style="margin-top: 40px;">
        <van-button round block type="info" native-type="submit">Submit</van-button>
      </div>
    </van-form>
    
  </div>
</template>

<script>
import { Toast, Dialog, ImagePreview } from "vant";

Toast.setDefaultOptions({ duration: 10000 });
export default {
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  data() {
    return {
      data1: "",
      data2: "",
      data3: "",
      data4: "",
      checkboxGroup: [],
    };
  },
  beforeCreate() {
  },
  created() {},
  methods: {
    onSubmit(values) {
      console.log(this.checkboxGroup);

      if(this.checkboxGroup.length < 2){
        Dialog({ 
          message: 'Please confirm terms',
          confirmButtonColor: '#1989fa',
        });
        return 
      }

      Dialog({ 
        message: 'Submit successfully, Please wait for the developer to process your request', 
        confirmButtonColor: '#1989fa'
      });

    },
  },
};
</script>

<style lang="scss">
.tusee-container-deactivate {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 30px;

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }



}
</style>
